import { ContactPlace } from "../../core/models";

export class ContactPlacesState {
    searchText: string = '';
    searchedPlaces: ContactPlace[] = [];
  }
